<template>
  <Teleport to="#modals">
    <div :class="$style.base" v-test="testId || undefined">
      <div ref="el" :class="$style.content" v-test="'modal-content'">
        <div
          v-if="!unclosable"
          :class="$style.close"
          @click="close"
          v-test="'modal-close'"
        >
          <IconClose />
        </div>
        {{ message }}
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import IconClose from '@/components/IconClose.vue';
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';

const props = defineProps<{
  message: string;
  testId?: string;
  unclosable?: boolean;
}>();

const emit = defineEmits(['close']);

const close = () => {
  if (props.unclosable) {
    return;
  }

  emit('close');
};

const el = ref();
onClickOutside(el, () => close());
</script>

<style lang="scss" module>
.base {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: $spacing;
  line-height: 25px;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.5);
}
.content {
  position: relative;
  width: 100%;
  padding: $spacing * 2;
  background-color: white;
  border-radius: 25px;
  box-shadow: 0 0 26px rgba(0, 0, 0, 0.25);
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  cursor: pointer;
  z-index: 1;
}
</style>
